<div class="p-col-12 p-lg-12">
  <div class="ui-g card">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      @for (message of msgs; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
      @if (showForm) {
        <form [formGroup]="paymentBatchForm" (ngSubmit)="onSubmit()">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-lg-6">
              <div class="reqfields">
                <span class="indicate">*</span> required fields
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Batch Create Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="paymentBatchScheduleDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Anticipated Payment Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="anticipatedPaymentDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Actual Payment Central Date</div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="actualPaymentCentralDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Payment Batch Status <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-select
                    [options]="paymentBatchStatus"
                    placeholder="Select"
                    formControlName="paymentBatchStatus"
                    optionLabel="status"></p-select>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g bdr">
            @if (loading) {
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-table
                #dt
                [columns]="engcols"
                editMode="row"
                [(selection)]="selectedEngagements"
                dataKey="engagementId"
                [value]="engagementList"
                selectionMode="multiple"
                [loadingIcon]="loadingIcon"
                [showLoader]="true"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                scrollHeight="500px"
                frozenWidth="275px"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                (onPage)="pageChange($event)"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top"
                (onFilter)="applyFilter($event)">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        dt.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        dt.filters['global']
                          ? $any(dt.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfo
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="reset()"
                        (keydown.enter)="reset()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>

                <ng-template #header let-columns>
                  <tr>
                    <th class="dashtable colchck" pFrozenColumn>
                      <p-tableHeaderCheckbox
                        [disabled]="editing"></p-tableHeaderCheckbox>
                    </th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th
                      [pSortableColumn]="'engagementId'"
                      class="colsmall"
                      pFrozenColumn>
                      Engagement ID<p-sortIcon
                        [field]="'engagementId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'engagementName'" class="colmedium">
                      Engagement Name<p-sortIcon
                        [field]="'engagementName'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'engagementSubType'"
                      class="colsmall">
                      Sub Type<p-sortIcon
                        [field]="'engagementSubType'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerName'" class="colsmall">
                      Partner Name<p-sortIcon
                        [field]="'partnerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeID'" class="colsmall">
                      Payee ID<p-sortIcon [field]="'payeeID'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'tier'" class="colsmall">
                      Milestone 2 Tier<p-sortIcon [field]="'tier'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'tier'" class="colsmall">
                      Milestone 2 Eng Type<p-sortIcon
                        [field]="'tier'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fundingAmount'" class="colsmall">
                      Funding Amount<p-sortIcon
                        [field]="'fundingAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerLocation'" class="colsmall">
                      Partner Location<p-sortIcon
                        [field]="'partnerLocation'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fiscalYear'" class="colsmall">
                      Fiscal Year<p-sortIcon
                        [field]="'fiscalYear'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentProfileStatus'"
                      class="colsmall">
                      ProfileStatus<p-sortIcon
                        [field]="'paymentProfileStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerPriority'" class="colsmall">
                      Partner Priority<p-sortIcon
                        [field]="'partnerPriority'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'blockedStatus'" class="colsmall">
                      Blocked Status<p-sortIcon
                        [field]="'blockedStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'sspaStatus'" class="colsmall">
                      SSPA Status<p-sortIcon
                        [field]="'sspaStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerId'" class="colsmall">
                      Partner ID<p-sortIcon [field]="'partnerId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeName'" class="colsmall">
                      Payee Name<p-sortIcon [field]="'payeeName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactName'" class="colsmall">
                      Contact Name<p-sortIcon
                        [field]="'contactName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactEmail'" class="colsmall">
                      Contact Email<p-sortIcon
                        [field]="'contactEmail'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'emailLanguage'" class="colsmall">
                      Email Language<p-sortIcon
                        [field]="'emailLanguage'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'accountCode'" class="colsmall">
                      Account Code<p-sortIcon
                        [field]="'accountCode'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'internalOrderOrCostCenter'"
                      class="colsmall">
                      Internal Order or<br />Cost Center<p-sortIcon
                        [field]="'internalOrderOrCostCenter'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'currency'" class="colxsmall">
                      Currency<p-sortIcon [field]="'currency'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'amount'" class="colxsmall">
                      Amount<p-sortIcon [field]="'amount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'taxAmount'" class="colxsmall">
                      Tax Amount<p-sortIcon [field]="'taxAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'msInvoiceNumber'" class="colmedium">
                      MS Invoice Number<p-sortIcon
                        [field]="'msInvoiceNumber'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'msInvoicePaidDate'"
                      class="colmedium">
                      MS Invoice Paid Date<p-sortIcon
                        [field]="'msInvoicePaidDate'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentCentralTransactionID'"
                      class="collarge">
                      Payment Central<br />Transaction ID<p-sortIcon
                        [field]="'paymentCentralTransactionID'"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th class="dashtable colchck" pFrozenColumn></th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th class="dashtable colsmall" pFrozenColumn>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementId']
                            ? $any(dt.filters['engagementId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementName']
                            ? $any(dt.filters['engagementName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementSubType',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementSubType']
                            ? $any(dt.filters['engagementSubType']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerName']
                            ? $any(dt.filters['partnerName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payeeID',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payeeID']
                            ? $any(dt.filters['payeeID']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'tier',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['tier']
                            ? $any(dt.filters['tier']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payoutMetric',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payoutMetric']
                            ? $any(dt.filters['payoutMetric']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'fundingAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['fundingAmount']
                            ? $any(dt.filters['fundingAmount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerLocation',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerLocation']
                            ? $any(dt.filters['partnerLocation']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'fiscalYear',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['fiscalYear']
                            ? $any(dt.filters['fiscalYear']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'paymentProfileStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['paymentProfileStatus']
                            ? $any(dt.filters['paymentProfileStatus']).value
                            : ''
                        " />
                    </th>

                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerPriority',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerPriority']
                            ? $any(dt.filters['partnerPriority']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'blockedStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['blockedStatus']
                            ? $any(dt.filters['blockedStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'sspaStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['sspaStatus']
                            ? $any(dt.filters['sspaStatus']).value
                            : ''
                        " />
                    </th>

                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerId']
                            ? $any(dt.filters['partnerId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payeeName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payeeName']
                            ? $any(dt.filters['payeeName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactName']
                            ? $any(dt.filters['contactName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactEmail',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactEmail']
                            ? $any(dt.filters['contactEmail']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'emailLanguage',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['emailLanguage']
                            ? $any(dt.filters['emailLanguage']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'accountCode',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['accountCode']
                            ? $any(dt.filters['accountCode']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'internalOrderOrCostCenter',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['internalOrderOrCostCenter']
                            ? $any(dt.filters['internalOrderOrCostCenter'])
                                .value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'currency',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['currency']
                            ? $any(dt.filters['currency']).value
                            : ''
                        " />
                    </th>

                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'amount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['amount']
                            ? $any(dt.filters['amount']).value
                            : ''
                        " />
                    </th>

                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'taxAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['taxAmount']
                            ? $any(dt.filters['taxAmount']).value
                            : ''
                        " />
                    </th>

                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoiceNumber',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoiceNumber']
                            ? $any(dt.filters['msInvoiceNumber']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoicePaidDate',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoicePaidDate']
                            ? $any(dt.filters['msInvoicePaidDate']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable collarge">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'paymentCentralTransactionID',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['paymentCentralTransactionID']
                            ? $any(dt.filters['paymentCentralTransactionID'])
                                .value
                            : ''
                        " />
                    </th>
                  </tr>
                </ng-template>
                <ng-template
                  #body
                  let-rowData
                  let-editing="editing"
                  let-columns="columns"
                  let-ri="rowIndex">
                  <tr [pEditableRow]="rowData" class="wa-uneven-height-fix">
                    <td
                      class="colchck"
                      class="wa-uneven-height-fix"
                      pFrozenColumn>
                      <p-checkbox
                        name="chcklist"
                        [disabled]="editing"
                        inputId="eng_chk_{{ rowData.engagementId }}"
                        [value]="rowData"
                        formControlName="selectedEngs"
                        (onChange)="selectRow($event, rowData)"
                        [(ngModel)]="selectedEngagements"></p-checkbox>
                    </td>
                    <td
                      class="dashtable coleditrow"
                      style="text-align: center"
                      pFrozenColumn></td>
                    <td class="colsmall" pFrozenColumn>
                      {{ rowData.engagementId }}
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementName }}"
                        >{{ rowData.engagementName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementSubType }}"
                        >{{ rowData.engagementSubType }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerName }}"
                        >{{ rowData.partnerName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.payeeID }}"
                        >{{ rowData.payeeID }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.tier }}"
                        >{{ rowData.tier }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.payoutMetric }}"
                        >{{ rowData.payoutMetric }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fundingAmount }}"
                        >{{ rowData.fundingAmount }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerLocation }}"
                        >{{ rowData.partnerLocation }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fiscalYear }}"
                        >{{ rowData.fiscalYear }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.paymentProfileStatus }}"
                        >{{ rowData.paymentProfileStatus }}</span
                      >
                    </td>

                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerPriority }}"
                        >{{ rowData.partnerPriority }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.blockedStatus }}"
                        >{{ rowData.blockedStatus }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.sspaStatus }}"
                        >{{ rowData.sspaStatus }}</span
                      >
                    </td>

                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.partnerId"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.partnerId }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.payeeName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.payeeName }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.contactName }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactEmail"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.contactEmail }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.emailLanguage"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.emailLanguage }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.accountCode"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.accountCode }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.internalOrderOrCostCenter
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.internalOrderOrCostCenter }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.currency"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.currency }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.amount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.amount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.taxAmount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.taxAmount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colmedium">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.msInvoiceNumber"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.msInvoiceNumber !== null &&
                            rowData.msInvoiceNumber !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{ rowData.msInvoiceNumber }}"
                              >{{ rowData.msInvoiceNumber }}</span
                            >
                          }
                          @if (
                            rowData.msInvoiceNumber === null ||
                            rowData.msInvoiceNumber === ''
                          ) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colcalendar">
                      <p-cellEditor>
                        <ng-template #input>
                          <p-datepicker
                            dataType="date"
                            dateFormat="dd/mm/yy"
                            [(ngModel)]="firstEditInitEng.msInvoicePaidDate"
                            [ngModelOptions]="{ standalone: true }"
                            [iconDisplay]="'input'"
                            [showIcon]="true"></p-datepicker>
                        </ng-template>
                        <ng-template #output>
                          @if (rowData.msInvoicePaidDate !== null) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.msInvoicePaidDate | date: 'dd/MM/yyyy'
                              }}"
                              >{{
                                rowData.msInvoicePaidDate | date: 'dd/MM/yyyy'
                              }}</span
                            >
                          }
                          @if (rowData.msInvoicePaidDate === null) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable collarge">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.paymentCentralTransactionID
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.paymentCentralTransactionID !== null &&
                            rowData.paymentCentralTransactionID !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.paymentCentralTransactionID
                              }}"
                              >{{ rowData.paymentCentralTransactionID }}</span
                            >
                          }
                          @if (
                            rowData.paymentCentralTransactionID === null ||
                            rowData.paymentCentralTransactionID === ''
                          ) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          @for (message of msgs; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-lg-12 mar10">
              <button
                type="submit"
                pButton
                [disabled]="!paymentBatchForm.valid || disableSubmit"
                class="flat btnmr">
                Submit
              </button>
              <button
                type="button"
                pButton
                (click)="cancelSearchNav()"
                class="ui-button-secondary flat">
                Cancel
              </button>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
